module.exports = __webpack_public_path__ + "static/img/headphone-icon.8dfcb1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/headphone-icon.png
// module id = BYAW
// module chunks = 16